import {cloneElement, createContext} from "react";
import React, {ReactElement} from "react";
import {IIconContext} from "./types/IICon";

export const IconContext = createContext<IIconContext>({
	icon: () => {
		throw new Error("Icon render not initialized, check library dependency. Likely issue with multiple context providers.")
	},
	menuIcon: <></>,
	logoutIcon: <></>,
	attachFileOutlinedIcon: <></>,
	circleIcon: <></>,
	lockIcon: <></>,
	checkCircleOutlinedIcon: <></>,
	chevronRightIcon: <></>,
	fileCopyIcon: <></>,
	downloadForOfflineIcon: <></>,
	expandMoreIcon: <></>,
	restoreFromTrashIcon: <></>,
	refreshIcon: <></>,
	cancelScheduleSendIcon: <></>,
	deleteIcon: <></>,
	contentPasteIcon: <></>,
	personIcon: <></>,
	chairAltIcon: <></>,
	engineeringIcon: <></>,
	visibilityIcon: <></>,
	visibilityOffIcon: <></>,
	localOfferOutlinedIcon: <></>,
	arrowBackIcon: <></>,
	arrowForwardIcon: <></>,
	doneIcon: <></>,
	sendOutlinedIcon: <></>,
	closeIcon: <></>,
	checkCircleIcon: <></>,
	errorIcon: <></>,
	cancelIcon: <></>,
	infoIcon: <></>,
	searchIcon: <></>,
	navigateNextIcon: <></>,
	starBorderIcon: <></>,
	starIcon: <></>,
	editIcon: <></>,
	keyboardArrowRightIcon: <></>,
	dragIndicatorIcon: <></>,
	autoFixNormalIcon: <></>,
	checkIcon: <></>,
	notificationsNoneOutlinedIcon: <></>
});

export interface IProps {
	children: ReactElement,
	icons: Omit<IIconContext, "icon">
}

export const IconProvider = (props: IProps): JSX.Element => {

	const icon: IIconContext["icon"] = (key, iconProps) => {
		return cloneElement(props.icons?.[key] ?? <></>, iconProps)
	}

	return (
		<IconContext.Provider value={{...props.icons, icon}}>
			{props.children}
		</IconContext.Provider>
	);
}

export default IconProvider;